export const Base64AppendString = 'data:image/jpeg;base64, ';
